export default {
  Error: {
    404: 'Opps! Không tìm thấy trang.',
    '404_sub': 'Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại',
    500: 'Internal Server Error!',
    '500_sub':
      'Có một số lỗi xảy ra, vui lòng liên hệ với MISA để được trợ giúp',
    403: 'OPPS! Bạn không có quyền truy cập vào trang này',
    '403_sub': 'Vui lòng liên hệ Quản trị hệ thống để được trợ giúp',
  },
  Button: {
    BackHome: 'Quay lại trang chủ',
    ByNow: 'Mua ngay',
    ActiveNow: 'Gia hạn ngay',
    DeleteUser: 'Xóa người dùng',
  },
};
